var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "winners",
    d: "M15.594240431064367,4.907859114533663 A1.8955420464634904,1.8955420464634904 0 0 1 15.133116364479065,3.779124094599485 V2.462774136286974 A0.4135812735378746,0.4135812735378746 0 0 1 15.527596890926361,2.0324668884277344 h3.9448052644729614 a0.4135812735378746,0.4135812735378746 0 0 1 0.3944805264472965,0.4303072478592398 V3.779124094599485 a1.8955420464634904,1.8955420464634904 0 0 1 -0.46112406658530236,1.1287350199341775 L18.288960576057434,6.766233205795288 v0.788961052894593 h0.3944805264472965 a0.3944805264472965,0.3944805264472965 0 0 1 0.3944805264472965,0.3944805264472965 v0.788961052894593 a0.3944805264472965,0.3944805264472965 0 0 1 -0.3944805264472965,0.3944805264472965 h-2.366883158683777 a0.3944805264472965,0.3944805264472965 0 0 1 -0.3944805264472965,-0.3944805264472965 v-0.788961052894593 a0.3944805264472965,0.3944805264472965 0 0 1 0.3944805264472965,-0.3944805264472965 H16.71103847026825 V6.766233205795288 zM26.178571105003357,13.866882681846619 H22.233765840530396 v3.155844211578369 a0.788961052894593,0.788961052894593 0 0 1 -1.5779221057891846,0 V10.71103847026825 a0.788961052894593,0.788961052894593 0 0 0 -0.788961052894593,-0.788961052894593 H15.133116364479065 a0.788961052894593,0.788961052894593 0 0 0 -0.788961052894593,0.788961052894593 v6.311688423156738 a0.788961052894593,0.788961052894593 0 0 1 -1.5779221057891846,0 V12.288960576057434 H8.821427941322327 a0.788961052894593,0.788961052894593 0 0 0 -0.788961052894593,0.788961052894593 V20.96753215789795 H26.96753215789795 V14.655843734741211 A0.788961052894593,0.788961052894593 0 0 0 26.178571105003357,13.866882681846619 z",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinners);
export default __webpack_public_path__ + "static/media/winners.a8e19d162510aa45edfed451ecd3c084.svg";
export { ForwardRef as ReactComponent };